import Vue from "vue";
import App from "./App.vue";
import Vuesax from "vuesax";
import VModal from "vue-js-modal";
import VoerroTagsInput from "@voerro/vue-tagsinput";
import "@voerro/vue-tagsinput/dist/style.css";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);
const {detect} = require("detect-browser");
const browser = detect();
switch (browser && browser.name) {
	case "ie":
	case "edge":
	case "edge-chromium":
		window.location.href = "https://www.mozilla.org/es-ES/firefox/new/";
		break;
	default:
		break;
}
import * as constants from "@/constants";
import axios from "./axios.js";
Vue.prototype.$http = axios;
import "./http/requests";
import "./fake-db/index.js";
import firebaseConfig from "@/constants/firebase";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
export const firebaseInstance = firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();
export const database = firebase.database();
Vue.prototype.$storage = firebase.storage();
Vue.prototype.$database = firebase.database();

import DBConfig from "./constants/IndexedDB";
import IndexedDB from "./helpers/IndexedDB";
import "../themeConfig.js";
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);
import acl from "./acl/acl";
import "./globalComponents.js";
import "./assets/scss/main.scss";
import "@/assets/css/main.css";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import "@/filters";
import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);
const GoogleMapsApiLoader = require("google-maps-api-loader");
GoogleMapsApiLoader({
	apiKey: constants.googleMapsApiKey,
	libraries: constants.libraries,
	version: "3.64",
})
	.then(
		function (googleApi) {
			console.info("GoogleMaps Api is loading...");
			if (!window.google) {
				window.google = googleApi;
			} else {
				console.info("GoogleMapsApi is loaded!");
			}
		},
		function (err) {
			console.error("GoogleMaps Api Loader Error:", err);
		}
	)
	.catch((err) => {
		console.error("EL_MAPA", err);
	});
import {VueHammer} from "vue2-hammer";
Vue.use(VueHammer);
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
require("./assets/css/iconfont.css");

Vue.use(VModal);

Vue.config.productionTip = false;

IndexedDB.init(DBConfig);
//retrieve token from IndexedDB
IndexedDB.first("users").then((result) => {
	if (result) {
		store.commit("SET_SESSION_TOKEN", result.access_token);
	}
});
Vue.component("tags-input", VoerroTagsInput);
new Vue({
	router,
	store,
	i18n,
	acl,
	render: (h) => h(App),
}).$mount("#app");
